import { render, staticRenderFns } from "./Standards.vue?vue&type=template&id=309c6a1a&scoped=true&"
import script from "./Standards.vue?vue&type=script&lang=js&"
export * from "./Standards.vue?vue&type=script&lang=js&"
import style0 from "./Standards.vue?vue&type=style&index=0&id=309c6a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309c6a1a",
  null
  
)

export default component.exports